import { render, staticRenderFns } from "./BillRecieve.vue?vue&type=template&id=00cbafc2"
import script from "./BillRecieve.vue?vue&type=script&lang=js"
export * from "./BillRecieve.vue?vue&type=script&lang=js"
import style0 from "./BillRecieve.vue?vue&type=style&index=0&id=00cbafc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports